import React from 'react'
import { formatBytes } from 'utils'

const File = ({ url, title, fileSize, onDelete, uploading = false }) => {
  const onClick = (event) => {
    event.stopPropagation()

    if (onDelete) {
      onDelete()
    }
  }

  return (
    <div className="bg-white border border-gray m-2 p-5 flex justify-between items-center cursor-default">
      <a href={url} target="_blank" className="truncate">
        <div className="text-primary font-medium truncate">{ title }</div>
        <div className="text-gray-500 text-sm">{ formatBytes(fileSize) }</div>
      </a>

      { uploading &&
          <i className="ml-3 fa fa-fal fa-sync text-gray-500 animate-spin" />
      }

      { onDelete &&
        <i className="ml-3 fa fa-fal fa-trash cursor-pointer text-gray-500 hover:text-gray-700" onClick={onClick} />
      }
    </div>
  )
}

export default File
